import styled from "@emotion/styled";
import { Box } from "../../../primitives/Box/Box";

export const CardContainer = styled(Box)`
  border-radius: 5px;
`;
